import { controls, grouped } from "../controls";
const report_acceptances = {
  label: "Accept Reports",
  pageLabel: "Accept Reports", starting: true, url: "autogen",
  formActions: { edit: { allow: true }, delete: { allow: false } },
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "Client" }),
    ...controls.oc({ tab: "filter", c: "Client", placeHolder: "Client Code", name: "ReportAcceptance-dcc_bank-client_code", fastpath: "clients" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "ReportAcceptance-dcc_bank-client_display" }),
    ...controls.displayText({ tab: "filter", label: "Report" }),
    ...controls.oc({ tab: "filter", c: "Report", placeHolder: "Report Code", name: "ReportAcceptance-report-report_code", fastpath: "reports", autoopen: true }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "ReportAcceptance-report-report_display" }),
  ]
  , form: [
    ...controls.displayText({ tab: "general", label: "DCC Bank", star: false }),
    ...controls.oc({ tab: "general", c: "Client", placeHolder: "DCC Bank", name: "dcc_bank_code", isRequired: false, fastpath: "clients", displayData: { client_display: "dcc_bank_display", client_uid: "dcc_bank_uid" } }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "dcc_bank_display" }),
    ...controls.displayText({ tab: "general", label: "Report", star: false }),
    ...controls.oc({ tab: "general", c: "Report", placeHolder: "Report Code", name: "report_code", isRequired: false, fastpath: "reports", autoopen: true }),
    ...controls.showData({ tab: "general", displaytype: "capital", data: "report_display" }),
    ...controls.magicDateLabel({ tab: "general", label: "Completion Date", target: "completion_date", star: false }),
    ...controls.magicDate({ tab: "general", name: "completion_date", dateType: "ontype", isRequired: false }),
    ...controls.displayText({ tab: "general", label: "", width: "col-sm-2" }),
    ...controls.displayText({ tab: "general", label: "Remarks", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "remarks", isRequired: false, width: "col-sm-4", maxlength: 100 }),
    ...controls.checkBox({ tab: "general", label: "Accept", default: false, name: "accept" }),
  ]
  , history: {
    perPage: 10,
    reportHeader: "Report Acceptances",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "Client", accessor: "ReportAcceptance-dcc_bank-client_display", },
      { Header: "Report", accessor: "ReportAcceptance-report-report_display", },
    ]
  }
};
export default report_acceptances;